// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/Switch/styles.scss
// module id = 822
// module chunks = 0